import React, { useEffect, useMemo, useRef, useState } from 'react'
import "./PlauditTrackStyles.css"

export default function PlauditTrack({ hubConnection, eventId, settings, preview }) {
    const { alignment = "right", backgroundColor = "#0000" } = settings;
    const parentRef = useRef();
    const [loopIsRunning, setLoopIsRunning] = useState(false);
    const [content, setContent] = useState([]);
    const loopRef = useRef(null);
    const [uploadedFiles, setUploadedFiles] = useState({});
    useEffect(() => {
        getUploadedIcons()
        return () => {
            if (loopRef.current) {
                clearInterval(loopRef.current)
            }
        }
    }, [])
    useEffect(() => {
        if (!preview) {
            if (hubConnection) {
                hubConnection.on("onSendReaction", onSendReaction);
            }
        }
        return () => {
            if (hubConnection) {
                hubConnection.off("onSendReaction", onSendReaction);
            }
        }
    })
    const onSendReaction = (name) => {
        content.push(new IconBurst(parentRef.current, uploadedFiles[name] ? uploadedFiles[name] : `https://cdn.jsdelivr.net/npm/twemoji@latest/2/svg/${name.toLowerCase()}.svg`));
        if (!loopIsRunning) {
            setLoopIsRunning(true);
            animate();
        }
    }
    const animate = () => {
        let i = 0;
        for (i = 0; i < content.length; ++i) {
            if (content[i].done) {
                content[i].flush();
                content.splice(i, 1);
            }
        }
        // animate
        for (i = 0; i < content.length; ++i) {
            content[i].update();
            content[i].draw();
        }
        if (content.length > 0) {
            requestAnimationFrame(animate);
        }
        else {
            setLoopIsRunning(false);
        }
    }
    const getUploadedIcons = () => {
        const requestOptions = {
            method: "GET",
        };
        fetch(
            `./api/files/icons/${eventId}`,
            requestOptions
        ).then((response) =>
            response.text().then((text) => {
                try {
                    const storageSummary = JSON.parse(text);
                    var files = {};
                    for (const file of storageSummary.files) {
                        files[file.name] = file.url;
                    }
                    setUploadedFiles(files);
                } catch (error) {
                    console.error("DOWNLOAD_ERROR", error);
                }
            })
        );
    };
    return <div ref={parentRef} className="plaudit-track" style={{ height: "100%", width: "100%", backgroundColor: backgroundColor }}></div>
}


class IconBurst {
    constructor(parent, src) {
        this.timestamp = Date.now();
        this.parent = parent;
        this.x = 0;
        this.y = 0;
        this.color = Math.floor(Math.random() * 360);
        this.phase = Math.random() * 360;
        this.radius = Math.random() * 1;
        this.speed = 4;
        this.scale = 0.4 + Math.random() * 0.8;
        this.grow = 0.01;
        this.alpha = 1;
        this.done = false;
        this.distance = this.parent.clientHeight * -1;
        this.outer = document.createElement("div");
        this.outer.className = `icon-outer`;

        /*  */

        this.outer.style.left = this.parent.clientWidth - 50 + "px";
        this.outer.style.top = this.parent.clientHeight - 30 + "px";
        this.inner = document.createElement("div");
        this.inner.className = `icon-inner`;
        this.inner.style.left = (this.parent.clientWidth / Math.floor(1 + (Math.random() * 3))) * -1 + "px"
        this.img = document.createElement("img")
        this.img.src = src
        this.inner.append(this.img);
        this.outer.appendChild(this.inner);
        this.parent.appendChild(this.outer);

        this.draw();
    }

    flush() {
        if (this.parent.contains(this.outer)) {
            this.parent.removeChild(this.outer);
        }
        this.outer = null;
        this.inner = null;
    }

    draw() {
        if (this.done) return;
        this.outer.style.transform = "translateX( " + this.x + "px ) translateY( " + this.y + "px ) translateZ( 0 ) scale( " + this.grow + " )";
        this.outer.style.opacity = this.alpha;
    }

    update() {
        this.alpha = this.alpha > 0 ? this.alpha - 0.0015 : this.alpha;
        this.alpha = this.alpha < 0 ? 0.4 : this.alpha;

        this.x += Math.cos(this.phase / 50) * this.radius;
        this.y -= this.speed;

        this.grow += (this.scale - this.grow) / 10;
        this.phase += 1;

        this.done = this.y < this.distance || this.alpha <= 0 || this.timestamp + 15000 < Date.now() ? true : false;
        //
    }
}